// frame 框架相关
export const TITLE = 'TITLE';

// globel 全局
export const USER_INFO = 'USER_INFO'; //用户信息
export const UPDATE_USER_ATTR_ID = 'UPDATE_USER_ATTR_ID';
export const SET_USER = 'SET_USER';//设置用户信息

// login 登陆相关
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const IS_LOGINDE = 'IS_LOGINDE'; //是否登录


//搜索相关
export const SEARCH_KEYWORD_LIST = 'SEARCH_KEYWORD_LIST';//随机获取的搜索关键词列表
export const LASTTEST_SEARCH_LIST = 'LASTTEST_SEARCH_LIST';//最近搜索
export const CLEAR_LASTTEST_SEARCH_LIST = 'CLEAR_LASTTEST_SEARCH_LIST';//清除最近搜索

//客服部分
export const CUSTOMER_SHREF = "CUSTOMER_SHREF";//客服链接

//晒家分享相关
export const SHARE_GOODS_LISTS = "SHARE_GOODS_LISTS";//商品列表
export const PAGENO = "PAGENO";
export const LASTPAGE = "LASTPAGE";


// 客户订单
export const ORDER_MSG = "ORDER_MSG";
export const ORDER_MATE = "ORDER_MATE"
export const TREE_DATA = "TREE_DATA"



// WEBPACK FOOTER //
// ./src/store/mutation-types.js